import React from 'react';
import PropTypes from 'prop-types';
import { Form, withFormik } from 'formik';
import { Button } from '../Button';
import { Input as FormInput } from '../Form/Input';
import { withInputClassNames } from './HOC';

const Input = withInputClassNames(FormInput);

const PasswordForgotForm = ({
  handleInputChange,
  currentEmail,
  handleUpdateActiveTab,
  clientTabActive,
  handleForgotPassword,
}) => (
  <Form className="forgot-form">
    <div className="form-row d-none">
      <div className="login__header">
        <div
          onClick={handleUpdateActiveTab}
          id="client"
          className={`login__header-element ${clientTabActive === true &&
            'login__header-element--active'}`}
        >
          Client Portal
        </div>
        <div
          onClick={handleUpdateActiveTab}
          id="freelancer"
          className={`login__header-element ${clientTabActive === false &&
            'login__header-element--active'}`}
        >
          Editor Portal
        </div>
      </div>
    </div>
    <div className="form-row">
      <div className="col mb-3">
        <p className="reset-password__form__form-header">Forgot Password?</p>
        <p className="t-15 text-gray-light">
          Enter your email below and we will send you a message with information
          on how to reset your password.
        </p>
      </div>
    </div>
    <div className="form-row">
      <Input
        type="email"
        name="currentEmail"
        label="Email"
        valuet={currentEmail}
        onChange={handleInputChange}
        className="login__content-input-raw"
      />
    </div>
    <div className="form-row">
      <Button
        type="submit"
        title="Send Email"
        className="btn-primary px-5 form-submit"
        onClick={handleForgotPassword}
      />
    </div>
  </Form>
);

PasswordForgotForm.propTypes = {
  handleInputChange: PropTypes.func,
  currentEmail: PropTypes.string,
  handleUpdateActiveTab: PropTypes.func,
  clientTabActive: PropTypes.bool,
  handleForgotPassword: PropTypes.func,
};

export const PasswordForgot = withFormik({
  displayName: 'PasswordForgot',
})(PasswordForgotForm);



// WEBPACK FOOTER //
// ./src/components/PasswordForgot/PasswordForgot.js